import { z } from 'zod';

const CentsSchema = z.string().regex(/^\d+$/, 'must be a non-negative integer string (cents)');

// GET|PUT /finance/places/:placeId/productive-labor-rate (BR-FIN-66)
export const SavePlaceProductiveLaborRateBodySchema = z.object({
  rateCents: CentsSchema,
});
export type SavePlaceProductiveLaborRateBody = z.infer<
  typeof SavePlaceProductiveLaborRateBodySchema
>;

export const SavePlaceProductiveLaborRateResponseSchema = z.object({
  placeId: z.uuid(),
  rateCents: CentsSchema,
  effectiveFrom: z.iso.datetime(),
});
export type SavePlaceProductiveLaborRateResponse = z.infer<
  typeof SavePlaceProductiveLaborRateResponseSchema
>;

export const PlaceProductiveLaborRatePresentSchema = z.object({
  present: z.literal(true),
  placeId: z.uuid(),
  rateCents: CentsSchema,
  effectiveFrom: z.iso.datetime(),
});

export const PlaceProductiveLaborRateAbsentSchema = z.object({
  present: z.literal(false),
  placeId: z.uuid(),
});

export const PlaceProductiveLaborRateResponseSchema = z.discriminatedUnion('present', [
  PlaceProductiveLaborRatePresentSchema,
  PlaceProductiveLaborRateAbsentSchema,
]);
export type PlaceProductiveLaborRateResponse = z.infer<
  typeof PlaceProductiveLaborRateResponseSchema
>;
